<div class="w-full mx-auto p-6 rounded-lg">
  <h2 class="titre2">{{ 'USERS_MANAGEMENT.INVITATION_RESULTS' | translate }}</h2>
  <mat-dialog-content>
    @if (data.utilisateursSucces.length > 0) {
      <h3 class="titre3">{{ 'USERS_MANAGEMENT.USERS_INVITED_SUCCESSFULLY' | translate }}</h3>
      <ul class="dark:text-white">
        @for (utilisateur of data.utilisateursSucces; track utilisateur) {
          <li>
            {{ utilisateur }}
          </li>
        }
      </ul>
    }

    @if (data.utilisateursAReactives.length > 0) {
      <h3>{{ 'USERS_MANAGEMENT.USERS_AREACTIVER' | translate }}</h3>
      <ul class="dark:text-white">
        @for (utilisateur of data.utilisateursAReactives; track utilisateur) {
          <li>
            {{ utilisateur.courriel }} ({{ utilisateur.entite }})
          </li>
        }
      </ul>
    }

    @if (data.utilisateursDejaPresents.length > 0) {
      <h3>{{ 'USERS_MANAGEMENT.USERS_ALREADY_REGISTERED' | translate }}</h3>
      <ul class="dark:text-white">
        @for (utilisateur of data.utilisateursDejaPresents; track utilisateur) {
          <li>
            {{ utilisateur.courriel }} ({{ utilisateur.entite }})
          </li>
        }
      </ul>
    }

    @if (data.utilisateursEnErreurs.length > 0) {
      <h3 class="titre3">{{ 'USERS_MANAGEMENT.USERS_WITH_ERRORS' | translate }}</h3>
      <ul class="dark:text-white">
        @for (utilisateur of data.utilisateursEnErreurs; track utilisateur) {
          <li>
            {{ utilisateur }}
          </li>
        }
      </ul>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">{{ 'USERS_MANAGEMENT.CLOSE' | translate }}</button>
  </mat-dialog-actions>
</div>
